import scroll_down from "../../_assets/images/scroll_down.png";
import scroll_down_2 from "../../_assets/images/scroll_down_2.png";
import scroll_down3 from "../../_assets/images/scroll_down3.png";
import scroll_down4 from "../../_assets/images/scroll_down4.png";
import { MainContainer, Container2, Container } from "../ComponentCss";
import { useEffect, useRef, useState } from "react";

const WeekendComponent = ({ playState, setBgIsBlack, setSupportVisible, setSpyEle }) => {
    const componentRef = useRef([]);
    const [answer, setAnswer] = useState('');
    const [answer2, setAnswer2] = useState('');

    // 오답 클릭 시 class 추가
    useEffect(() => {
        if (answer !== '') {
            const chageAnswer = setInterval(() => {
                setAnswer('')
            }, 500);
            return () => clearInterval(chageAnswer);
        } else if (answer2 !== '') {
            const chageAnswer = setInterval(() => {
                setAnswer2('')
            }, 500);
            return () => clearInterval(chageAnswer);
        }
    }, [answer, answer2]);

    const componentContRef = useRef();
    const [constBotom, setConstBotom] = useState();
    
    const whiteBgRef = useRef();
    const [wBgTop, setWBgTop] = useState();
    
    const startEleRef = useRef();
    const [startEleTop, setStartEleTop] = useState();

    useEffect(() => {
        setWBgTop(whiteBgRef.current.getBoundingClientRect().top + window.pageYOffset);
        setStartEleTop(startEleRef.current.getBoundingClientRect().top + window.pageYOffset);
        setConstBotom(componentContRef.current.getBoundingClientRect().bottom + window.pageYOffset);
    }, [whiteBgRef, startEleRef, componentContRef]);

    const scrollBGCheckHandler = () => {
        
        if (playState === "weekend") {
            if (window.scrollY + 100 > wBgTop) setBgIsBlack(false);
            else setBgIsBlack(true);

            if (window.scrollY + 100 > wBgTop && window.scrollY + 100 < wBgTop + window.innerHeight - 200) {
                setSupportVisible(true);
                setSpyEle('weekend');
            } else if (window.scrollY < startEleTop - 500) {
                setSupportVisible(true);
                setSpyEle('weekend');
            } else if (window.scrollY > constBotom) {
                setBgIsBlack(true);
                setSpyEle('');
            } else {
                setSupportVisible(false);
                setSpyEle('weekend');
            }
        } else if (playState === "" && window.scrollY > constBotom) {
            setBgIsBlack(true);
            setSpyEle('');
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", scrollBGCheckHandler);
        return () => {
        window.removeEventListener("scroll", scrollBGCheckHandler);
        };
    });

    return (
        <MainContainer ref={ componentContRef } spyEle={ playState }>
            <Container2 className="p-11-w" ref={ el => componentRef.current[0] = el }>
                <div className="comm">
                    <p>당신이 주말에 <br className="mo" />친구들과 들고나간 것은?</p>
                    <div className="label-cont">
                        <label className="correct" htmlFor="weekend1" onClick={() => componentRef.current[1].scrollIntoView({behavior: "smooth"})}>
                            <input type="checkbox" id="weekend1" />
                            야구공과 배트
                        </label>
                        <label className={ answer } htmlFor="weekend2" onClick={() => setAnswer('wrong') }>
                            <input type="checkbox" id="weekend2" />
                            총과 수류탄
                        </label>
                    </div>
                </div>
                <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img pc" />
                <img src={ scroll_down3 } alt="scroll down 이미지" className="scroll_img2 mo" />
            </Container2>
            <Container2 className="p-12" ref={ el => componentRef.current[1] = el }>
                <div className="comm">
                    <p className="opacity">당신이 주말에 <br className="mo" />친구들과 들고나간 것은?</p>
                    <div className="label-cont">
                        <label className="correct" htmlFor="weekend1_res">
                            <input type="checkbox" id="weekend1_res" defaultChecked disabled />
                            야구공과 배트
                        </label>
                        <label htmlFor="weekend2_res" className="opacity">
                            <input type="checkbox" id="weekend2_res" disabled/>
                            총과 수류탄
                        </label>
                    </div>
                </div>
                <div className="scroll-cont">
                    <p>
                        주말에 지구 반대편의 10살 마제르는 무슨 이야기를 들었을까요?
                    </p>
                    <img src={ scroll_down4 } alt="scroll down 이미지" className="pc" />
                    <img src={ scroll_down3 } alt="scroll down 이미지" className="mo" />
                </div>
            </Container2>            
            <Container2 className="p-13 item-right t-s" ref={ el => componentRef.current[2] = el }>
                <div className="comm">
                    <p>다음 중 10살 마제르가<br />주말에 친구들과 들고나간 것은?</p>
                    <div className="label-cont">
                        <label className={ answer2 } htmlFor="weekend3" onClick={() => setAnswer2('wrong') }>
                            야구공과 배트
                            <input type="checkbox" id="weekend3" />
                        </label>
                        <label className="correct" htmlFor="weekend4" onClick={() => componentRef.current[3].scrollIntoView({behavior: "smooth"})}>
                            총과 수류탄
                            <input type="checkbox" id="weekend4" />
                        </label>
                    </div>
                </div>
                <img src={ scroll_down } alt="scroll down 이미지" className="scroll_img pc" />
                <img src={ scroll_down3 } alt="scroll down 이미지" className="scroll_img2 mo" />
                <span className="copyright copyright-r">©UNICEF/ UN0276000/Rich</span>
            </Container2>
            <Container2 className="p-14 item-right t-s" ref={ el => componentRef.current[3] = el }>
                <div className="comm">
                    <p className="opacity">다음 중 10살 마제르가<br />주말에 친구들과 들고나간 것은?</p>
                    <div className="label-cont">
                        <label htmlFor="weekend3_res" className="opacity">
                            야구공과 배트
                            <input type="checkbox" id="weekend3_res" disabled />
                        </label>
                        <label className="correct" htmlFor="weekend4_res">
                            총과 수류탄
                            <input type="checkbox" id="weekend4_res" defaultChecked disabled />
                        </label>
                    </div>
                </div>
                <div className="scroll-cont">
                    <p>
                        스크롤을 내려 마제르의 이야기 들어보기
                    </p>
                    <img src={ scroll_down4 } alt="scroll down 이미지" className="pc" />
                    <img src={ scroll_down3 } alt="scroll down 이미지" className="mo" />
                </div>
                <span className="copyright copyright-r">©UNICEF/ UN0276000/Rich</span>
            </Container2>
            <Container className="p-4" ref={ startEleRef }>
                <div className="comm" style={{ marginTop: "7rem" }}>
                    <div>
                        <p className="not_asmr">
                            유니세프 응답하기 캠페인
                        </p>
                        <video controls>
                            <source src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_TVC.f0f4cbdb28e448a672be.mp4" } type="video/mp4" alt="전쟁 TVC" />
                        </video>
                    </div>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="아이들의 목소리에 응답하기">
                        아이들의 목소리에 응답하기
                    </button>
                </div>
            </Container>
            <Container className="p-15">
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_img1.4b9f9292132fd79a4c0f.jpg" } className="pc" alt="전쟁 문제 이미지1" style={{ width: "24.5rem", marginTop: "0.5rem" }} />
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_img1_m.cb31c06ff582a7c5ac55.png" } className="mo" alt="전쟁 문제 이미지1" />
                <div className="comm">
                    <p className="comm-point">
                        “무장단체에 들어오지 않으면 <br className="mo" />총을 쏘겠다고 협박했어요”<br/>
                        <span>10살 아이가 소년병이 될 수밖에 없었던 이유</span>
                    </p>
                    <p className="comm-basic" style={{ fontFamily: "AggroL, sans-serif" }}>
                        10살 마제르의 악몽은 <br className="mo" />남자가 건넨 40달러를 받으면서 시작됐습니다.<br/>
                        자신을 따라오면 돈을 더 준다는 말에 <br className="mo" />의심 없이 따라간 곳에서<br className="pc" />
                        살해 협박을 받은 마제르는 <br className="mo" />10살의 나이에 총을 들 수밖에 없었습니다.
                    </p>
                    <p className="comm-basic">
                        전 세계 소년병 최대 25만 명 추정<br />
                        강제로 소년병이 되는 아이들 매년 2천 명 이상
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="악몽 같은 생활에서 아이들 구해주기">
                        악몽 같은 생활에서 아이들 구해주기
                    </button>
                </div>
                <span className="copyright">©UNICEF/ UN0275999</span>
            </Container>
            <Container className="p-16">
                <div className="comm">
                    <p className="comm-point">
                        “어떤 아이는 지뢰를 밟아서 다리가<br />잘려나가기도 했어요 ”<br/>
                        <span style={{ fontSize: "inherit" }}>생명의 위협에 무방비로 노출되는 소년병들</span>
                    </p>
                    <p className="comm-basic" style={{ fontFamily: "AggroL, sans-serif" }}>
                        마제르가 무장단체에 들어간 순간부터 <br className="mo" />가혹한 생활은 시작됐습니다.<br/>
                        낮에는 적군의 총알이 날아오거나 지뢰가 묻혀있을 수 있는 <br className="mo" />지역을 순찰했고<br className="pc" />
                        밤에는 훈련이라는 명목하에 <br className="mo" />무장단체의 무자비한 폭력에 노출되었습니다.
                    </p>
                    <p className="comm-basic">
                        2019년 19개국에서 소년병에 대한 폭행 및 살해, 성폭행 등<br />
                        심각한 어린이 권리 침해 사례 2만 5천 건 확인
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="악몽 같은 생활에서 아이들 구해주기">
                        악몽 같은 생활에서 아이들 구해주기
                    </button>
                </div>
                <img src={  "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_img2.344bacd3034ee08857e4.jpg" } className="pc" alt="전쟁 문제 이미지2" style={{ paddingLeft: "3%", width: "25rem" }} />
                <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_img2_m.e0618d1dac5fe7b30a55.png" } className="mo" alt="전쟁 문제 이미지2" />
                <span className="copyright">©UNICEF/ UN041953</span>
            </Container>
            <Container className="p-7" ref={ whiteBgRef }>
                <div className="comm p-w-bg">
                    <p style={{ fontFamily: "AggroM,sans-serif", margin: "0" }}>
                        강제로 소년병이 된 <br className="mo" />마제르의 가혹한 현실에<br />
                        <span>유니세프가 응답</span> 했습니다
                    </p>
                </div>
                <img src={ scroll_down_2 } alt="scroll down 이미지2" className="scroll_img" style={{ width: "19rem" }} />
            </Container>
            <Container className="p-8 p-18">
                <div className="comm p-w-bg">
                    <p className="comm-tit">
                        “이제 다시 안심하고 <br className="mo" />잠을 잘 수 있어요”<br />
                        무장단체에서 해방돼 미래를 <br className="mo" />꿈꾸는 아이들
                    </p>
                    <p className="comm-point comm-point2">
                        영원히 이어질 것만 같던 마제르의 끔찍한 날들은 <br className="mo" />유니세프 덕분에 끝을 맺었습니다.<br/>
                        유니세프가 무장단체와 지속적으로 접촉하고 <br className="mo" />교섭한 결과 마제르를 포함한<br/>
                        250명의 아이들을 소년병에서 구출할 수 있었습니다.<br/>
                        구출 이후 마제르는 유니세프의 지원프로그램을 통해 <br className="mo" />목수 훈련을 받고 있습니다.<br className="pc" />
                        다시 미래를 꿈꿀 수 있는 <br className="mo" />마제르는 더 이상 악몽에 시달리지 않습니다.
                    </p>
                    <p className="comm-basic">
                        유니세프 2013년부터 3,780명의 소년병 구출<br />
                        구출된 아동에게 직업교육 등의 재통합 프로그램 제공
                    </p>
                    <button onClick={ () => window.open('https://www.unicef.or.kr/donate/?supportTerm=FM01&supportCategory=D001&solicitcode=DR22E') } alt="아이들 미래 지원해 주기">
                        아이들 미래 지원해 주기
                    </button>
                </div>
            </Container>
        </MainContainer>
    );
}

export default WeekendComponent;
